export default __webpack_public_path__ + "static/media/Kaushan-Regular.b721b739.ttf";